
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { hasActiveCCTeamRole } from "@/hooks/use-cc-team-roles";

export function DefaultDashboardRedirect() {
  const [loading, setLoading] = useState(true);
  const [teamId, setTeamId] = useState<string | null>(null);
  const [isParentOnly, setIsParentOnly] = useState(false);

  useEffect(() => {
    const determine = async () => {
      const lastTeamId = localStorage.getItem("lastTeamId");
      setTeamId(lastTeamId);

      // If no team, check if user is a parent-only user
      if (!lastTeamId) {
        try {
          const { data: { session } } = await supabase.auth.getSession();
          if (session) {
            // Check if user owns or collaborates on any teams
            const { data: ownedTeams } = await supabase
              .from("teamvote_teams")
              .select("id")
              .eq("coach_id", session.user.id)
              .limit(1);

            const { data: accessTeams } = await supabase
              .from("team_access")
              .select("id")
              .eq("email", session.user.email || "")
              .limit(1);

            const hasTeams = (ownedTeams && ownedTeams.length > 0) || (accessTeams && accessTeams.length > 0);

            if (!hasTeams) {
              // Check CC team roles before falling back to parent
              const hasCCRole = await hasActiveCCTeamRole(session.user.id);
              if (!hasCCRole) {
                // Check guardian status
                const { data: guardians } = await supabase
                  .from("gameon_parent_guardians")
                  .select("id")
                  .eq("user_id", session.user.id)
                  .in("status", ["active", "pending"])
                  .limit(1);

                if (guardians && guardians.length > 0) {
                  setIsParentOnly(true);
                }
              }
            }
          }
        } catch (err) {
          console.error("Error checking roles:", err);
        }
      }

      setLoading(false);
    };

    determine();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary" />
      </div>
    );
  }

  if (isParentOnly) {
    return <Navigate to="/parent" replace />;
  }

  if (teamId) {
    return <Navigate to={`/teams/${teamId}/dashboard`} replace />;
  }

  return <Navigate to="/teams" replace />;
}
